import { useSearchParamsManager } from '@/hooks/use-search-params';
import FieldEditorRenderer from './components/FieldEditorRenderer';
import { FieldEditorContextProps, FieldEditorProvider } from './context/FieldEditorContext';

export const FieldEditorModalPage = (props: FieldEditorContextProps) => {
  const { searchParams, setSearchParams } = useSearchParamsManager();

  const returnToPage = searchParams.get('returnToPage') || '';

  const handleCloseFieldEditorModalPage = () => {
    if (returnToPage === 'fieldConfiguration') {
      setSearchParams(
        (prev) => {
          prev.delete('returnToPage');
          prev.set('fieldEditorModalPageType', 'fieldConfiguration');
          return prev;
        },
        { replace: true }
      );
      return;
    }
    props.handleClose();
  };

  return (
    <FieldEditorProvider {...props} handleClose={handleCloseFieldEditorModalPage}>
      <FieldEditorRenderer />
    </FieldEditorProvider>
  );
};
